function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useContext, createRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CFade from '../fade/CFade';
import { omitByKeys } from '@coreui/utils/src';
import { CFadeProps } from '../utils/helper.js';
import { Context } from './CTabs.js';
import { Context as FadeContext } from './CTabContent.js'; //component - CoreUI / CTabPane

var getIndex = function getIndex(el) {
  return Array.from(el.parentNode.children).indexOf(el);
};

var getState = function getState(r) {
  return r.current.dataset.tab || getIndex(r.current);
};

var CTabPane = function CTabPane(props) {
  var className = props.className,
      innerRef = props.innerRef,
      active = props.active,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "innerRef", "active"]);

  var context = useContext(Context);
  var fade = useContext(FadeContext);
  var act = (context || {}).active;
  var ref = createRef();
  innerRef && innerRef(ref);

  var _useState = useState(active),
      isActive = _useState[0],
      setIsActive = _useState[1];

  useEffect(function () {
    setIsActive(active !== undefined ? active : act === getState(ref));
  }, [act, active]); //render

  var classes = classNames('tab-pane', {
    'active': isActive
  }, className);
  var attrs = omitByKeys(attributes, CFadeProps);
  return /*#__PURE__*/React.createElement(CFade, _extends({
    "in": isActive,
    baseClass: fade ? 'fade' : '',
    className: classes
  }, attrs, {
    innerRef: ref
  }));
};

CTabPane.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  //
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.object]),
  active: PropTypes.bool
} : {};
export default CTabPane;